export const MESSAGE = {
	LABEL: 'Invitation Link Expired',
	DESCRIPTION: `	The invitation link you received to join Simplici Inc. has expired
						and is no longer valid. Please contact account owner for a new
						invitation link.`,
};
